import React from "react";
import { EmailFormField } from "cerulean";
import useRevalidateErroringField from "../hooks/useRevalidateErroringField";

type EmailFieldProps = {
  revalidateErrorsOnBlur?: boolean;
};

const EmailField = ({ revalidateErrorsOnBlur = false }: EmailFieldProps) => {
  const revalidateErroringField = useRevalidateErroringField("email");

  return (
    <EmailFormField
      required
      onBlur={revalidateErrorsOnBlur ? revalidateErroringField : undefined}
      key="email"
    />
  );
};

export default EmailField;
